// 導覽列 - 語言切換、收藏、通知、頭像、登入註冊按鈕
import { useDispatch, useSelector } from 'react-redux';
import {
    setShowLanguageModal,
    setShowNotifyModal,
    setShowUserModal,
    popState,
} from '@/slices/popSlice';

import ToggleLanguageButton from './ToggleLanguageButton'; // 語言切換 按鈕
import LoginButton from './LoginButton'; // 登入註冊按鈕
import UserNotify from '../user/UserNotify'; // 通知按鈕
import UserThumbnail from '../user/UserThumbnail'; // 頭像
import { DEFAULT_USER_IMG } from '@/common/constant';
// import UserCollect from '../user/UserCollect'; // 收藏按鈕

const UserFunction = ({ user }) => {
    const dispatch = useDispatch();
    const { showUserModal, showNotifyModal } = useSelector(popState);

    return (
        <div
            className={`flex items-center gap-x-[10px] [&>*]:trans [&>*]:rounded-[50%] [&>*]:w-[32px] [&>*]:h-[32px]
            [&>*]:center-center [&>*]:border-1 [&>*]:border-opacity-[.32] [&>*_img]:trans
            ${user?.uid ? '' : 'usm:!gap-x-0'} [&>*]:border-[#fff] [&_img]:filter-white
            ulg:[&>*]:!border-opacity-[.32]`}
        >
            {/* 語言切換 */}
            <ToggleLanguageButton dispatch={dispatch} setShowLanguageModal={setShowLanguageModal} />

            {user?.uid ? (
                // 有登入才顯示
                <>
                    {/* 收藏按鈕 */}
                    {/* <UserCollect /> */}

                    {/* 通知按鈕 */}
                    <UserNotify
                        uid={user?.uid}
                        dispatch={dispatch}
                        showNotifyModal={showNotifyModal}
                        setShowNotifyModal={setShowNotifyModal}
                    />

                    {/* 頭像 */}
                    <UserThumbnail
                        dispatch={dispatch}
                        setShowUserModal={setShowUserModal}
                        showUserModal={showUserModal}
                        thumbnail={user?.image || DEFAULT_USER_IMG}
                        avatarFrame={user?.avatarFrame}
                    />
                </>
            ) : (
                // 登入註冊按鈕
                <LoginButton />
            )}
        </div>
    );
};

export default UserFunction;
